<template>
  <div class="f_o p_t">
    <TopHead title="填写订单"></TopHead>
    <div class="o_top_card">
      <div class="d_f tag_out">
        <div class="tag" :style="{backgroundColor : info.bgColor}">{{info.commodityTypeName}}</div>
        <span class="flex_1">{{info.commodityName}}</span>
      </div>
      <div class="pri_out d_f ali_b j_s">
        <span>
          <span>{{stockInfo.startTime.split(' ')[0]+'——'+stockInfo.endTime.split(' ')[0]}}</span> ·
          <!--共<span>{{count(stockInfo.startTime,stockInfo.endTime)}}</span>天 ·-->
          共<span>{{info.duration}}</span> ·
          <span>{{stockInfo.displayName}}</span>
        </span>
        <div>
          <span class="price">￥<span>{{info.sellPrice ? info.sellPrice/100 :0}}</span></span>
          <div class="price_sub" v-if="params.orderType == 1"><span>{{info.guardianNum}}</span>大<span>{{info.studentNum}}</span>小</div>
        </div>
      </div>
    </div>
    <!--预订人信息-->
    <div class="order_per">
      <div class="op_title d_f ali_c">
        <span>预订人信息</span>
        <span class="flex_1">建议填写监护人信息</span>
        <div class="d_f ali_c j_c info_btn" @click="isShowUsualPer = true">
          <span>常用联系人</span>
          <van-icon name="arrow"/>
        </div>
      </div>
      <div class="items d_f ali_c">
        <span>中文名字</span>
        <input type="text" placeholder="请输入正确的名字" class="flex_1" v-model="params.linkmenName">

        <van-icon name="clear" class="delete_icon" v-if="params.linkmenName" @click="params.linkmenName = ''"/>
      </div>
      <div class="items d_f ali_c b_n">
        <span>电话号码</span>
        <input type="text" placeholder="用于应急联系" class="flex_1" v-model="params.telephone">
        <van-icon name="clear"  class="delete_icon" v-if="params.telephone" @click="params.telephone = ''"/>
      </div>
    </div>
    <!--非亲子类学生报名信息-->
    <div class="per_info" v-if="params.orderType == 0">
      <div class="per_top d_f ali_b j_s">
        <div class="ti">学生报名信息</div>
        <div class="flex_1">填写学生信息</div>
        <div class="d_f ali_c j_c cur_p info_btn" @click="isShowUsualInfo = true">
          <span>常用信息</span>
          <van-icon name="arrow"/>
        </div>
      </div>
      <div class="per_item d_f ali_c" v-for="(item,index) in params.applicantInfoList" :key="index">
        <van-icon name="clear" @click="params.applicantInfoList.splice(index,1)" v-if="params.applicantInfoList.length>1"/>
        <div class="name">学生<span>{{index+1}}</span></div>
        <div class="flex_1">
          <div class="bb d_f ali_c j_s">
            <input type="text" placeholder="须与证件上的名字一致" class="flex_1" v-model="item.applicantName">
            <van-icon name="clear"  class="delete_icon" v-if="item.applicantName" @click="item.applicantName = ''"/>
          </div>
          <div class="d_f ali_c j_s">
            <input type="text" placeholder="请填写证件证件号码" class="flex_1" v-model="item.cardNo">
            <van-icon name="clear"  class="delete_icon" v-if="item.cardNo" @click="item.cardNo = ''"/>
          </div>
          <div class="bb d_f ali_c j_s" v-if="info.schoolFlag && info.schoolFlag == 1">
            <span class="flex_1" :class="item.schoolName ? 'ac' : ''" @click="showSchool(index)">{{item.schoolName || '请选择学校'}}</span>
            <van-icon name="clear"  class="delete_icon" v-if="item.applicantName" @click="item.applicantName = ''"/>
          </div>
          <div class="bb d_f ali_c j_s" v-if="info.schoolFlag && info.schoolFlag == 1">
            <span class="flex_1" :class="item.schoolGrade ? 'ac' : ''" @click="showGrade(index)">{{item.schoolGrade ? columns2[0].values[item.schoolGrade-1].name+columns2[1].values[item.schoolClass-1].name : '请选择年级与班级'}}</span>
            <van-icon name="clear"  class="delete_icon" v-if="item.applicantName" @click="item.applicantName = ''"/>
          </div>
        </div>
      </div>
      <div class="add_per_btn d_f ali_c j_c" @click="addStu">
        <van-icon name="add-o" />
        <span>新增学生信息</span>
      </div>

      <div class="check_out d_f ali_c" v-if="isShowCheck">
        <van-checkbox v-model="isRead" checked-color="#24BDDD" icon-size="18px"></van-checkbox>
        <span>我已阅读同意</span>
        <span class="text" @click="showInfoPop('gjzs')">《<span>家长告知书</span>》</span>
        <span>和</span>
        <span class="text" @click="showInfoPop('xqzbd')">《<span>行程准备单</span>》</span>
      </div>
    </div>
    <!--亲子类报名人信息-->
    <div class="per_info" v-else>
      <div class="per_top d_f ali_b j_s">
        <div class="ti">报名信息</div>
      </div>
      <div class="per_item" v-for="(item,index) in params.applicantInfoList" :key="index">
        <div class="d_f ali_c j_s">
          <div class="name">{{item.applicantType == 1 ? '学生' : '家长'}}</div>
          <div class="d_f ali_c j_c cur_p info_btn" @click="chooseOne(item,index)">
            <span>常用信息</span>
            <van-icon name="arrow"/>
          </div>
        </div>
        <div class="flex_1">
          <div class="bb d_f ali_c j_s">
            <input type="text" placeholder="须与证件上的名字一致" class="flex_1" v-model="item.applicantName">
            <van-icon name="clear"  class="delete_icon" v-if="item.applicantName" @click="item.applicantName = ''"/>
          </div>
          <div class="d_f ali_c j_s">
            <input type="text" placeholder="请填写证件证件号码" class="flex_1" v-model="item.cardNo">
            <van-icon name="clear"  class="delete_icon" v-if="item.cardNo" @click="item.cardNo = ''"/>
          </div>
        </div>
      </div>
      <div class="check_out d_f ali_c">
        <van-checkbox v-model="isRead" checked-color="#24BDDD" icon-size="18px"></van-checkbox>
        <span>我已阅读同意</span>
        <span class="text">《<span>家长告知书</span>》</span>
        <span>和</span>
        <span class="text">《<span>行程准备单</span>》</span>
      </div>
    </div>

    <!--温馨提示-->
    <div class="per_tip">
      <div class="per_ti">{{tsInfo.title}}</div>
      <div v-html="tsInfo.contentInfo"></div>
    </div>

    <!--底部按钮-->
    <div class="per_b_btn">
      <span v-if="params.orderType == 0">报名人数：<span>{{params.applicantInfoList.length}}</span>人</span>
      <span v-else>报名费用：</span>
      <span class="pri_o t_r" v-if="params.orderType == 0"><span>总计：</span><span class="price">￥<span>{{info.sellPrice ? (info.sellPrice/100)*params.applicantInfoList.length :0}}</span></span></span>
      <!--亲子类总价-->
      <span class="pri_o t_l" v-else><span class="price">￥<span>{{info.sellPrice ? (info.sellPrice/100) :0}}</span></span></span>

      <div @click="createOrder">提交订单</div>
    </div>

    <!--选择常用联系人弹窗-->
    <van-action-sheet v-model:show="isShowUsualPer">
      <div class="per_pop">
        <div class="per_pop_top d_f ali_c j_s">
          <span @click="isShowUsualPer = false">取消</span>
          <span>选择常用联系人</span>
          <span class="sure" @click="sureLinkMen">确定</span>
        </div>
        <div class="per_pop_check">
          <div class="check_item d_f ali_c" v-for="(item,index) in linkmenArr" :key="index">
            <img src="../assets/img/fo_check.png" alt="" v-if="acLinkmen == index" @click="acLinkmen = null">
            <img src="../assets/img/fo_check_dis.png" alt="" v-else @click="acLinkmen = index">
            <!--<van-checkbox v-model="item.isCheck" shape="square" checked-color="#24BDDD" icon-size="18px"></van-checkbox>-->
            <div class="flex_1 d_f ali_c">
              <div class="flex_1">
                <div class="name">{{item.linkmenName}}</div>
                <div>电话号码 : <span>{{item.telephone}}</span></div>
              </div>
              <van-icon name="delete-o" @click="deleteLinkmen(item,index)"/>
            </div>
          </div>
        </div>
      </div>
    </van-action-sheet>


    <!--选择常用信息弹窗非亲子类-->
    <van-action-sheet v-model:show="isShowUsualInfo">
      <div class="per_pop">
        <div class="per_pop_top d_f ali_c j_s">
          <span @click="isShowUsualInfo = false">取消</span>
          <span>选择常用信息</span>
          <span class="sure" @click="sureUser">确定</span>
        </div>
        <div class="per_pop_check">
          <div class="check_item d_f ali_c info" v-for="(item,index) in userArr" :key="index">
            <van-checkbox v-model="item.isCheck" shape="square" checked-color="#24BDDD" icon-size="18px"></van-checkbox>
            <div class="flex_1 d_f ali_c">
              <div class="name_out">
                <div class="name">{{item.applicantName}}</div>
              </div>
              <div class="flex_1 phone">{{item.cardNo}}</div>
              <van-icon name="delete-o" @click="deleteUser(item,index)"/>
            </div>
          </div>
        </div>
      </div>
    </van-action-sheet>

    <!--选择常用信息弹窗亲子类-->
    <van-action-sheet v-model:show="isShowUsualInfoQz">
      <div class="per_pop">
        <div class="per_pop_top d_f ali_c j_s">
          <span @click="isShowUsualInfoQz = false">取消</span>
          <span>选择常用信息</span>
          <span class="sure" @click="sureUserQz">确定</span>
        </div>
        <div class="per_pop_check">
          <div class="check_item d_f ali_c info" v-for="(item,index) in userArr" :key="index">
            <img class="p_r" src="../assets/img/fo_check.png" alt="" v-if="acUser == index" @click="acUser = null">
            <img class="p_r" src="../assets/img/fo_check_dis.png" alt="" v-else @click="acUser = index">
            <div class="flex_1 d_f ali_c">
              <div class="name_out">
                <div class="name">{{item.applicantName}}</div>
              </div>
              <div class="flex_1 phone">{{item.cardNo}}</div>
              <van-icon name="delete-o" @click="deleteUser(item,index)"/>
            </div>
          </div>
        </div>
      </div>
    </van-action-sheet>

    <!--学校picker-->
    <van-popup v-model:show="isShowSchool" round position="bottom">
      <van-picker
        :columns="columns"
        value-key="schoolName"
        title="请选择学校"
        @confirm="onConfirm"
        @cancel="onCancel"
      />
    </van-popup>

    <!--班级年级picker-->
    <van-popup v-model:show="isShowNJ" round position="bottom">
      <van-picker
        :columns="columns2"
        title="请选择年级与班级"
        value-key="name"
        @confirm="onConfirmNJ"
        @cancel="onCancelNJ"
      />
    </van-popup>

    <infoPop :code="code" v-if='showPopInfo' @close="showPopInfo = false"></infoPop>
  </div>
</template>

<script>
  import infoPop from '../components/infoPop'
  export default {
    name: "FillOrder",
    components:{
      infoPop
    },
    watch:{
      isShowUsualPer(n,o){
        if(!n){
          this.acLinkmen = null;
        }
      },
      isShowUsualInfoQz(n,o){
        if(!n){
          this.acUser = null;
        }
      },
    },
    data() {
      return {
        columns:[],
        columns2:[
          {
            values: [
              {value:1,name:'一年级'},
              {value:2,name:'二年级'},
              {value:3,name:'三年级'},
              {value:4,name:'四年级'},
              {value:5,name:'五年级'},
              {value:6,name:'六年级'},
              {value:7,name:'七年级'},
              {value:8,name:'八年级'},
              {value:9,name:'九年级'},
              {value:10,name:'十年级'},
              {value:11,name:'十一年级'},
              {value:12,name:'十二年级'}],
            defaultIndex: 2,
          },
          // 第二列
          {
            values: [],
            defaultIndex: 1,
          },
        ],
        isShowSchool:false,
        isShowNJ:false,
        isRead:false,
        showPopInfo:false,
        isShowUsualPer:false,
        isShowUsualInfo:false,
        isShowUsualInfoQz:false,
        isShowCheck:true,
        tsInfo:{},
        stockInfo:{startTime:'',endTime:''},
        info:{},
        params:{
          orderType:0,
          commodityId:this.$route.query.commodityId,
          stockId:this.$route.query.stockId,
          linkmenName:'',
          telephone:'',
          totalPrice:0,
          applicantInfoList:[
            {
              applicantType:'1',//监护人0 学生1
              applicantName:'',
              cardNo:'',
              schoolCode:'',
              schoolName:'',
              schoolGrade:'',
              schoolClass:'',
            }
          ]
        },
        linkmenArr:[],
        userArr:[],
        acLinkmen:null,
        acUser:null,
        code:'',
        chooseQzIndex:'',//亲子类常用联系人index
        acSchool:0,
        acGrade:0,
      }
    },
    created(){
      for(let i = 1;i<100;i++){
        this.columns2[1].values.push({value:i,name:i+'班'})
      }
      this.queryContentByCode();
      this.queryContentByCodejz();
      this.queryContentByCodexc();
      this.getCommodityStock();
      this.getCommodity();
      this.listLinkmen();
      this.listUserApplicant();
      this.listSchool();
    },
    methods: {
      //班级
      onConfirmNJ(value, index){
        this.params.applicantInfoList[this.acGrade].schoolGrade = value[0].value;
        this.params.applicantInfoList[this.acGrade].schoolClass = value[1].value;
        this.isShowNJ = false;
        console.log(value, index)
      },
      onCancelNJ(value, index){
        this.isShowNJ = false;
      },
      //学校确认
      onConfirm(value, index){
        console.log(value, index)
        this.params.applicantInfoList[this.acSchool].schoolCode = value.schoolCode;
        this.params.applicantInfoList[this.acSchool].schoolName = value.schoolName;
        this.isShowSchool = false;
      },
      onCancel(value, index){
        this.isShowSchool = false;
      },
      showGrade(i){
        this.acGrade = i;
        this.isShowNJ = true;
      },
      showSchool(i){
        this.acSchool = i;
        this.isShowSchool = true;
      },
      // 获取学校列表
      listSchool(){
        this.$api.listSchool().then(res => {
          this.columns = res.data;
        })
      },
      //亲子类选择常用信息确认
      sureUserQz(){
        let name = JSON.parse(JSON.stringify(this.userArr[this.acUser])).applicantName;
        let cardNo = JSON.parse(JSON.stringify(this.userArr[this.acUser])).cardNo;
        let isReapet = false;
        this.params.applicantInfoList.map(item => {
          if(item.applicantName == name && item.cardNo == cardNo){
            isReapet = true;
          }
        });
        if(isReapet) return this.$toast('选择重复');
        this.params.applicantInfoList[this.chooseQzIndex].applicantName = name;
        this.params.applicantInfoList[this.chooseQzIndex].cardNo = cardNo;
        this.isShowUsualInfoQz = false;
        this.acUser = null;
      },
      //亲子类选择常用信息
      chooseOne(row,index){
        this.chooseQzIndex = index;
        this.isShowUsualInfoQz = true;
      },
      isRepeat(arr) {
        var hash = {};
        for (var i in arr) {
          if (hash[arr[i]]){
            return true;
          }
          hash[arr[i]] = true;
        }
        return false;
      },
      //提交订单
      createOrder(){
        if(localStorage.getItem('status') == 0) return this.$toast('该账户已被限制购买，请联系营地工作人员解决');
        if(this.isShowCheck && !this.isRead) return this.$toast('请同意家长告知书以及行程准备单');
        if(!this.params.linkmenName || !this.params.telephone) return this.$toast('请输入联系人信息');
        if(!this.checkMobile(this.params.telephone)) return this.$toast('手机号输入错误');
        let isInputAll = true;
        this.params.applicantInfoList.map(item => {
          if(item.cardNo == '' && item.applicantName == ''){
            isInputAll = false
          }
        });
        if(!isInputAll) return this.$toast('请完善报名信息');
        let isPass = true;
        this.params.applicantInfoList.map(item => {
          if(!this.validateIdCard(item.cardNo)){
            isPass = false;
          }

        });
        if(!isPass) return this.$toast('身份证号码有误');

        let arr = [];
        if(this.params.applicantInfoList.length > 1){
          this.params.applicantInfoList.map(item => {
            arr.push(item.cardNo);
          });
        };
        if(this.isRepeat(arr)) return this.$toast('报名信息重复');

        if(!this.info.schoolFlag){
          this.params.applicantInfoList.map(item => {
            delete item.schoolGrade;
            delete item.schoolClass;
            delete item.schoolCode;
            delete item.schoolName;
          });
        }else{
          let isPassSchool = true;
          let isPassGrade = true;
          this.params.applicantInfoList.map(item => {
            if(!item.schoolCode){
              isPassSchool = false;
            }
            if(!item.schoolGrade){
              isPassGrade = false;
            }
          });
          if(!isPassSchool) return this.$toast('请选择学校');
          if(!isPassGrade) return this.$toast('请选择年级与班级');
        }
        if(this.params.orderType == 1){
          this.params.totalPrice = this.info.sellPrice;
        }else{
          this.params.totalPrice = this.info.sellPrice*this.params.applicantInfoList.length;
        }
        console.log(this.params)
        this.$api.createOrder(JSON.parse(JSON.stringify(this.params))).then(res => {
          this.$router.push('/SureOrder?orderNo='+res.data.orderNo+'&orderType='+res.data.orderType+'&sellNum='+res.data.sellNum +'&sellPrice='+res.data.sellPrice+'&commodityId='+this.params.commodityId
            +'&linkmenName='+this.params.linkmenName
            +'&telephone='+this.params.telephone
            +'&stockId='+this.params.stockId+'&orderId='+res.data.orderId);
        })
      },
      //家长告知书弹窗
      showInfoPop(code){
        this.showPopInfo = true;
        this.code = code;
      },
      //常用使用人确定
      sureUser(){
        let checkNum = 0;//得到选中的人数（亲子类判断）
        this.userArr.map(item => {
          if(item.isCheck){
            checkNum++
          }
        });
        if(this.params.orderType == 1 && checkNum > 2){//亲子类最多只能选择两个人
          return this.$toast('超出选择人数')
        }
        let needInputNum = 0;
        this.params.applicantInfoList.map(item => {
          if(item.cardNo == '' && item.applicantName == ''){
            needInputNum++
          }
        });
        if(this.params.orderType == 0 && checkNum > needInputNum){//非亲子类最多不能超过学生长度
          return this.$toast('超出选择人数')
        }
        let isReapet = false;
        this.params.applicantInfoList.map(item => {
          this.userArr.map(itm => {
            if(itm.isCheck){
              if(item.cardNo == itm.cardNo && item.applicantName == itm.applicantName){
                isReapet = true
              }
            }
          })
        });
        //非亲子类重复选择
        if(isReapet) return this.$toast('选择重复');


        this.userArr.map(itm => {
          itm.hasPush = false;
          if(itm.isCheck){
            this.params.applicantInfoList.map((item,idx) => {
              if(!itm.hasPush){
                if(item.cardNo == '' && item.applicantName == ''){
                  itm.hasPush = true;
                  item.cardNo = itm.cardNo;
                  item.applicantName = itm.applicantName;
                  item.applicantType = '1';
                }
              }
            });
          }
        })
        this.userArr.map(item => {
          item.isCheck = false;
        });

        this.isShowUsualInfo = false;
      },
      //删除常用使用人
      deleteUser(row,index){
        this.$dialog.confirm({
          message: '是否删除该使用人',
          confirmButtonColor:'#24BDDD',
        }).then(() => {
          this.$api.delUserApplicant({applicantId:row.applicantId}).then(res => {
            this.$toast('操作成功');
            this.userArr.splice(index,1)
          })
        })
      },
      //查询常用使用人
      listUserApplicant(){
        this.$api.listUserApplicant({pageIndex:1,pageSize:100}).then(res => {
          this.userArr = res.data.rows;
          this.userArr.map(item => {
            item.isCheck = false;
          })
        })
      },
      //常用联系人确认
      sureLinkMen(){
        if(this.acLinkmen == null) return this.$toast('请选择常用联系人');
        this.params.linkmenName = this.linkmenArr[this.acLinkmen].linkmenName;
        this.params.telephone = this.linkmenArr[this.acLinkmen].telephone;
        this.isShowUsualPer = false;
      },
      //删除常用联系人
      deleteLinkmen(row,index){
        this.$dialog.confirm({
          message: '是否删除该联系人',
          confirmButtonColor:'#24BDDD',
        }).then(() => {
          this.$api.delLinkmen({linkmenId:row.linkmenId}).then(res => {
            this.$toast('操作成功');
            this.linkmenArr.splice(index,1)
          })
        })
      },
      //获取常用联系人
      listLinkmen(){
        this.$api.listLinkmen({pageIndex:1,pageSize:100}).then(res => {
          this.linkmenArr = res.data.rows;
        })
      },
      //点击新增学生按钮
      addStu(){
        this.params.applicantInfoList.push({
          applicantType:'1',//监护人0 学生1
          applicantName:'',
          cardNo:'',
          schoolCode:'',
          schoolName:'',
          schoolGrade:'',
          schoolClass:'',
        })
      },


      validateIdCard: function(idCard) {
        let vcity={ 11:"北京",12:"天津",13:"河北",14:"山西",15:"内蒙古",
          21:"辽宁",22:"吉林",23:"黑龙江",31:"上海",32:"江苏",
          33:"浙江",34:"安徽",35:"福建",36:"江西",37:"山东",41:"河南",
          42:"湖北",43:"湖南",44:"广东",45:"广西",46:"海南",50:"重庆",
          51:"四川",52:"贵州",53:"云南",54:"西藏",61:"陕西",62:"甘肃",
          63:"青海",64:"宁夏",65:"新疆",71:"台湾",81:"香港",82:"澳门",91:"国外"
        };
        //是否为空
        if(idCard === ''){
          return false;
        }
        //校验长度，类型
        if(this.isCardNo(idCard) === false){
          return false;
        }
        //检查省份
        if(this.checkProvince(idCard,vcity) === false){
          return false;
        }
        //校验生日
        if(this.checkBirthday(idCard) === false){
          return false;
        }
        //检验位的检测
        if(this.checkParity(idCard) === false){
          return false;
        }
        return true;
      },
      isCardNo: function(card) {
        let reg = /(^\d{15}$)|(^\d{17}(\d|X|)$)/;
        if(reg.test(card) === false){
          return false;
        }
        return true;
      },
      checkProvince: function(card,vcity) {
        let province = card.substr(0,2);
        if(vcity[province] == undefined){
          return false;
        }
        return true;
      },
      checkBirthday: function(card) {
        let len = card.length,year,month,day,birthday;
        //身份证15位时，次序为省（3位）市（3位）年（2位）月（2位）日（2位）校验位（3位），皆为数字
        if(len == '15'||len == '18'){
          year = len == '15'?'19'+card.substr(6,2):card.substr(6,4),
            month = len == '15'?card.substr(8,2):card.substr(10,2),
            day = len == '15'?card.substr(10,2):card.substr(12,2);
          birthday = new Date(year+'/'+month+'/'+day);
          return this.verifyBirthday(year,month,day,birthday);
        }
        return false;
      },
      verifyBirthday: function(year,month,day,birthday) {
        var now = new Date();
        var now_year = now.getFullYear();
        //年月日是否合理
        if(birthday.getFullYear() == year && (birthday.getMonth() + 1) == month && birthday.getDate() == day)
        {
          let time = now_year - year;
          if(time >= 0 && time <= 100)
          {
            return true;
          }
          return false;
        }
        return false;
      },
      changeFivteenToEighteen: function(card) {
        if(card.length == '15')
        {
          let arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2),
            arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'),
            cardTemp = 0, i;
          card = card.substr(0, 6) + '19' + card.substr(6, card.length - 6);
          for(i = 0; i < 17; i ++)
          {
            cardTemp += card.substr(i, 1) * arrInt[i];
          }
          card += arrCh[cardTemp % 11];
          return card;
        }
        return card;
      },
      checkParity: function(card){
        //15位转18位
        card = this.changeFivteenToEighteen(card);
        var len = card.length;
        if(len == '18'){
          var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
          var arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
          var cardTemp = 0, i, valnum;
          for(i = 0; i < 17; i ++) {
            cardTemp += card.substr(i, 1) * arrInt[i];
          }
          valnum = arrCh[cardTemp % 11];
          if (valnum == card.substr(17, 1).toLocaleUpperCase())
          {
            return true;
          }
          return false;
        }
        return false;
      },
      //验证手机号
      checkMobile(str) { //写一个判断函数
        let  re = /^1\d{10}$/;    //正则表达式
        let isPass = false;
        if (re.test(str)) {      //判断字符是否是11位数字
          isPass = true;
        }else {
          isPass = false;
        }
        return isPass
      },
      //查询商品详情
      getCommodity(){
        this.$api.getCommodity({commodityId:this.$route.query.commodityId}).then(res => {
          this.info = res.data;
          if(this.info.guardianNum > 0 || this.info.studentNum > 0){
            this.params.orderType = 1
          }else{
            this.params.orderType = 0
          }
          if(this.params.orderType == 1){
            this.params.applicantInfoList = [];
            for(let i = 0;i<this.info.guardianNum;i++){
              this.params.applicantInfoList.push({
                applicantType:'0',//监护人0 学生1
                applicantName:'',
                cardNo:'',

              })
            }
            for(let i = 0;i<this.info.studentNum;i++){
              this.params.applicantInfoList.push({
                applicantType:'1',//监护人0 学生1
                applicantName:'',
                cardNo:'',
              })
            }
          }
        })
      },
      //计算日期之间相差多少天
      count(d1,d2){
        let date1=new Date(d1);
        let date2=new Date(d2);
        let date=(date2.getTime()-date1.getTime())/(1000*60*60*24);/*不用考虑闰年否*/
        return date
      },
      //查询库存
      getCommodityStock(){
        this.$api.getCommodityStock({commodityId:this.$route.query.commodityId}).then(res => {
          let id = this.$route.query.stockId;
          res.data.map(item => {
            if(item.stockId == id){
              this.stockInfo = JSON.parse(JSON.stringify(item))
            }
          })
        })

      },
      //获取温馨提示
      queryContentByCode(){
        this.$api.queryContentByCode('wxts').then(res => {
          this.tsInfo = JSON.parse(JSON.stringify(res.data));
        })
      },
      //获取家长告知书
      queryContentByCodejz(){
        this.$api.queryContentByCode('gjzs').then(res => {
         if(res.data.synopsis == 'n'){
           this.isShowCheck = false;
         }
        })
      },
      //获取星辰准备但
      queryContentByCodexc(){
        this.$api.queryContentByCode('xqzbd').then(res => {
          if(res.data.synopsis == 'n'){
            this.isShowCheck = false;
          }
        })
      },

    }
  }
</script>

<style scoped lang="scss">
  /*.f_o{
    .van-picker{
      position: fixed;
      z-index: 999;
      bottom: 0;
      left: 0;
      width: 100%;
    }
  }*/
  .price_sub{
    font-size: 12px;
    font-weight: 500;
    color: #909090;
    /*margin-top: 2px;*/
  }

</style>
